import { Component, OnInit } from '@angular/core';

import { SubscribeRedirectGuard } from 'src/providers/guard/subscribe-redirect.guard';

@Component({
  template: `
    <div class="subscribe-redirect-overlay">
      <div class="subscribe-redirect-card">
        <img src="assets/img/bowtie-white.svg" alt="TIDY" class="subscribe-redirect-logo" />
        <tidy-text [header]="'Opening subscription'" />
        <tidy-text [helper]="'Please wait...'" />
        <div class="subscribe-redirect-progress-track">
          <div class="subscribe-redirect-progress-bar"></div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .subscribe-redirect-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: var(--tidy-primary-layer-background, #000);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
    }
    .subscribe-redirect-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding: 40px 48px;
      border-radius: 12px;
      background: var(--tidy-primary-layer-card-background, #1a1a1a);
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
      min-width: 280px;
      text-align: center;
    }
    .subscribe-redirect-logo {
      width: 48px;
      height: auto;
      margin-bottom: 4px;
    }
    .subscribe-redirect-progress-track {
      width: 100%;
      height: 4px;
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.1);
      overflow: hidden;
      margin-top: 8px;
    }
    .subscribe-redirect-progress-bar {
      width: 40%;
      height: 100%;
      border-radius: 2px;
      background: #41cab7;
      animation: progressSlide 1.5s ease-in-out infinite;
    }
    @keyframes progressSlide {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(350%); }
    }
  `],
  standalone: false
})
export class SubscribeRedirectComponent implements OnInit {

  constructor(
    private subscribeRedirectGuard: SubscribeRedirectGuard
  ) {}

  async ngOnInit() {
    await this.subscribeRedirectGuard.handleRedirect();
  }
}
